import { html, TemplateResult, CSSResultGroup } from 'lit';
import { customElement } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { SlotsNGController as SlotsController } from '../../controllers/slots-ng-controller';
import componentStyles from './sic-nonprofit-detail.css.lit';

/**
 * The nonprofit detail component
 * @element sic-nonprofit-detail
 *
 * @slot heading
 * @slot description
 * @slot list-1 (needs)
 * @slot list-2 (opportunities)
 *
 * Lightdom styles in sic-nonprofit-detail.lightdom.css included in /shared.css
 */

@customElement('sic-nonprofit-detail')
export class SicNonprofitDetail extends OutlineElement {
  private slots = new SlotsController(this);
  static styles: CSSResultGroup = [componentStyles];

  render(): TemplateResult {
    return html`<sic-container background-color="primary-lightest">
      <div class="header">
        ${this.slots.conditionalSlot('heading')}
        ${this.slots.conditionalSlot('description', false)}
      </div>
      <div class="info">
        ${this.slots.conditionalSlot('list-1', false)}
        ${this.slots.conditionalSlot('list-2', false)}
      </div></sic-container
    >`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'sic-nonprofit-detail': SicNonprofitDetail;
  }
}
